import { apiFetch } from "@/lib/api";

export type ProductionTestOutcome = "pass" | "fail" | "skip" | "error";
export type ProductionTestEffectiveStatus = "pass" | "fail" | "pending";
export type ProductionTestScopeStatus =
  | "current_episode_and_calibration"
  | "no_uploads"
  | "no_valid_calibration";

export interface ProductionTestEffectiveRow {
  testKey: string;
  testName: string;
  sortOrder: number;
  status: ProductionTestEffectiveStatus;
  latestOutcome: ProductionTestOutcome | null;
  latestResultId: number | null;
  latestRunId: number | null;
  historyCount: number;
}

export interface ProductionTestRunRow {
  id: number;
  pcbaSerial: string;
  serialFciId: number | null;
  finishedSku: string | null;
  pcbaCalibrationId: number | null;
  sequenceName: string | null;
  sequenceSet: string | null;
  sequenceVersion: string | null;
  runKind: "full" | "retest";
  expectedTestKeys: string[];
  startedAt: string | null;
  finishedAt: string | null;
}

export interface ProductionTestResultHistoryRow {
  id: number;
  runId: number;
  testKey: string;
  testName: string;
  sortOrder: number;
  outcome: ProductionTestOutcome;
  detail: unknown;
  recordedAt: string;
  runKind: "full" | "retest";
  runFinishedAt: string | null;
}

export interface ProductionTestDeviceStatus {
  scopeStatus: ProductionTestScopeStatus;
  serialFciId: number | null;
  pcbaCalibrationId: number | null;
  finishedSku: string | null;
  sequenceName: string | null;
  sequenceSet: string | null;
  sequenceVersion: string | null;
  expectedTestKeys: string[];
  tests: ProductionTestEffectiveRow[];
  runs: ProductionTestRunRow[];
  history: ProductionTestResultHistoryRow[];
}

export interface ProductionTestStatusDeviceEntry {
  mcuUuid?: string;
  serialFciId?: number;
  status: ProductionTestDeviceStatus | null;
}

export interface ProductionTestStatusResponse {
  devices: ProductionTestStatusDeviceEntry[];
}

export const CAL_TEST_PRODUCTION_TEST_STATUS_QUERY_KEY = "manufacturing-cal-test-production-test-status";

export function fetchProductionTestStatusByMcuUuids(mcuUuids: string[]): Promise<ProductionTestStatusResponse> {
  const params = new URLSearchParams({ mcuUuids: mcuUuids.join(",") });
  return apiFetch<ProductionTestStatusResponse>(
    `/api/manufacturing/cal-test/production-test-status?${params.toString()}`,
  );
}

export function fetchProductionTestStatusBySerialFciId(serialFciId: number): Promise<ProductionTestStatusResponse> {
  const params = new URLSearchParams({ serialFciId: String(serialFciId) });
  return apiFetch<ProductionTestStatusResponse>(
    `/api/manufacturing/cal-test/production-test-status?${params.toString()}`,
  );
}
